module.exports = __webpack_public_path__ + "img/ccompany-honor-TPD-20240411.d28d9754.jpg";